// middleware/auth.global.js

export default defineNuxtRouteMiddleware((to, from) => {
    // На сервере (SSR) localStorage недоступен, выполняем проверку только на клиенте
    if (import.meta.server) return;

    // Список защищенных страниц (поддерживает маски с *)
    const protectedRoutes = [
        '/projects',
        '/profile',
        'projects/chat/*',
    ];

    // Функция проверки пути
    const isPathProtected = (targetPath, patterns) => {
        return patterns.some(pattern => {
            const normalizedPattern = pattern.startsWith('/') ? pattern : '/' + pattern;

            if (normalizedPattern.includes('*')) {
                const regexString = '^' + normalizedPattern
                    .replace(/[.+^${}()|[\]\\]/g, '\\$&')
                    .replace(/\\\*/g, '.*') + '$';
                return new RegExp(regexString).test(targetPath);
            }

            return targetPath === normalizedPattern || targetPath.startsWith(normalizedPattern + '/');
        });
    };

    const token = localStorage.getItem('authToken');

    // Если страница защищена, а токена нет — перенаправляем на /login
    if (isPathProtected(to.path, protectedRoutes) && !token) {
        return navigateTo('/login');
    }
});
